import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const defaultMimeType = 'application/json';

const accountApiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: { 'Content-Type': defaultMimeType, Accept: defaultMimeType }
});

// Add a request interceptor
accountApiInstance.interceptors.request.use(requestInterceptor);

export default accountApiInstance;



// WEBPACK FOOTER //
// ./src/common/api/accountApi.js